export default {
  finish: 'Finished today',
  title: 'Please annotate according to the requirements',
  pause: 'Pause',
  play: 'Play',
  stop: 'Stop',
  zoomin: 'Zoom in',
  zoomout: 'Zoom out',
  add: 'Add',
  loading: 'Loading',
  current: 'Present',
  editor: 'Notes',
  save: 'Save',
  js: {
    valid: 'Valid',
    noValid: 'Invalid',
    errVoice: 'Audio loading failed, please confirm whether the audio is valid',
    error: 'Failure',
    errMessage: 'Your browser may not support temporary preservation',
    success: 'Success',
    sucMessage: 'Save success',
    validinfo1: 'please make sure all annotation reach the quality standard',
    validinfo2: 'End time',
    validinfo3: 'No.',
    validinfo4: 'is not finished',
    validinfo5: 'audio did not complete the transfer',
    validinfo6: 'audio, the answer cannot match the question',
    validinfo7: 'audio'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/voiceExample.js